import { Flow, Text } from 'bold-ui'
import { Ellipsis } from 'components/Ellipsis'

import { AnexoArquivoRowModel, categoriaAnexoLabelRecord } from '../../objetivo/anexo-arquivos/model-anexoArquivos'
import { ContentCardSection } from '../components/ContentCardSection'

interface AnexoArquivosCardProps {
  ultimosArquivos: AnexoArquivoRowModel[]
  loading: boolean
  canRender: boolean
}

export const AnexoArquivosCard = (props: Readonly<AnexoArquivosCardProps>) => {
  const { ultimosArquivos, loading, canRender } = props

  return (
    <ContentCardSection
      isLoading={loading}
      messageLoading='Carregando arquivos anexados'
      canRender={canRender}
      dataTestId='AnexoArquivosCard.Content'
    >
      <Flow direction='vertical' gap={0.5}>
        {ultimosArquivos.map((anexo) => (
          <AnexoCardItem anexo={anexo} key={anexo.id} />
        ))}
      </Flow>
    </ContentCardSection>
  )
}

interface AnexoCardItemProps {
  anexo: AnexoArquivoRowModel
}

const AnexoCardItem = (props: Readonly<AnexoCardItemProps>) => {
  const { anexo } = props
  return (
    <Flow direction='vertical' gap={0}>
      <Text fontWeight='bold'>{categoriaAnexoLabelRecord[anexo.categoria]}</Text>
      <Ellipsis component='p'>{anexo.titulo}</Ellipsis>
    </Flow>
  )
}
